import { Link } from 'react-router-dom';
import { Facebook, Instagram,   Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-deep-black text-white py-12 relative overflow-hidden">
      {/* Subtle Gold Accent */}
      <div className="absolute inset-0 bg-gradient-to-r from-luxury-gold/10 to-transparent opacity-30"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="animate-fade-in-up">
            <div className="text-3xl font-playfair font-bold mb-4 drop-shadow-md">
              Pinnacle <span className="text-luxury-gold">Premiere</span> Limo
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Premium limousine transportation services offering luxury and comfort. Your premier choice for professional transportation in Houston and Richmond, TX.
            </p>
            <div className="flex space-x-4">
              {[
                { href: "https://facebook.com/pinnaclepremierlimo", icon: Facebook },
                { href: "https://instagram.com/pinnaclepremierlimo", icon: Instagram },
              
              ].map((social, idx) => (
                <a 
                  key={idx} 
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-luxury-gold transition-all duration-300 bg-gray-800 p-2 rounded-full hover:scale-125"
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Services Section */}
          <div className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <h3 className="font-playfair font-semibold text-xl mb-4 text-luxury-gold">Services</h3>
            <ul className="space-y-3 text-gray-300">
              {[
                "Airport Transfers",
                "Corporate Events",
                "Special Occasions",
                "Hourly Service",
                "Custom Packages",
              ].map((item, idx) => (
                <li key={idx}>
                  <Link to="/services">
                    <span className="hover:text-luxury-gold hover:border-b-2 border-luxury-gold transition-all duration-300 cursor-pointer">
                      {item}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <h3 className="font-playfair font-semibold text-xl mb-4 text-luxury-gold">Quick Links</h3>
            <ul className="space-y-3 text-gray-300">
              {[
                { to: "/", label: "Home" },
                { to: "/services", label: "Services" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
                // { to: "/privacy-policy", label: "Privacy Policy" },
              ].map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to}>
                    <span className="hover:text-luxury-gold hover:border-b-2 border-luxury-gold transition-all duration-300 cursor-pointer">
                      {link.label}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info Section */}
          <div className="bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <h3 className="font-playfair font-semibold text-xl mb-4 text-luxury-gold">Contact Info</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center group">
                <Phone className="h-4 w-4 mr-2 text-luxury-gold" />
                <a 
                  href="tel:+12814286921" 
                  className="hover:text-luxury-gold transition-all duration-300 group-hover:underline"
                >
                  (281) 428-6921
                </a>
              </li>
              <li className="flex items-center group">
                <Mail className="text-luxury-gold h-4 w-4 flex-shrink-0" />
                <a 
                  href="mailto:black@pinnaclepremierlimo.com" 
                  className="hover:text-luxury-gold transition-all duration-300 group-hover:underline"
                >
                  black@pinnaclepremierlimo.com
                </a>
              </li>
              <li className="flex items-center">
                <MapPin className="h-4 w-4 mr-2 text-luxury-gold" />
                <span>Houston & Richmond, TX</span>
              </li>
              <li className="flex items-center text-luxury-gold font-semibold">
                <Clock className="h-4 w-4 mr-2" />
                <span>24/7 Available</span>
              </li>
            </ul>
            <div className="mt-6">
              <Link to="/contact">
                <button className="bg-luxury-gold text-deep-black hover:bg-yellow-600 font-semibold px-6 py-2 text-sm transform hover:scale-105 transition-all duration-300 flex items-center justify-center w-full animate-pulse">
                  <Phone className="mr-2 h-4 w-4" />
                  Book Now
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-luxury-gold pt-8 text-center text-gray-300 animate-fade-in-up">
          <p>© Copyright 2025 Pinnacle Premiere Limo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}